import {
  Home,
  About,
  Products,
  Error,
  Cart,
  Product,
  SignUp,
  Login,
} from "./pages";
import { Checkout, Footer, Header, Loader } from "./components";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { getProductsApi } from "./api";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { setFilteredProducts, setProducts } from "./actions";
import styled from "styled-components";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  const getProducts = async () => {
    setIsLoading(true);
    try {
      const data = await getProductsApi();
      dispatch(setProducts(data));
      dispatch(setFilteredProducts(data));
    } catch (error) {
      console.log(error);
      // dispatch(setProducts([]));
      // dispatch(setFilteredProducts([]));
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <>
      <Router>
        {isLoading ? (
          <LoaderWrapper>
            <Loader></Loader>
          </LoaderWrapper>
        ) : (
          <>
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="cart" element={<Cart />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="products" element={<Products />} />
                <Route path="products/:id" element={<Product />} />
                <Route path="checkout" element={<Checkout />} />
                <Route path="*" element={<Error />} />
              </Routes>
            </main>
            <Footer></Footer>
          </>
        )}
      </Router>
    </>
  );
}

const LoaderWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: grid;
  align-items: center;
`;

export default App;
